<template>
  <div>
    <cpv-header></cpv-header>
    <div id="content" class="main-content d-flex align-items-center justify-content-center min-vh-100">
      <router-view></router-view>
    </div>
    <vue-snotify></vue-snotify>
  </div>
</template>

<script>
import cpvHeader from "@/components/global/header.vue";

export default {
  name: "AuthLayout",
  components: {
    cpvHeader,
  },
};
</script>

<style scoped>
.main-content {
  font-family: "Clan-Book Book", "FF Clan Pro", sans-serif !important;
}
.viewFooter {
  display: block;
}
.hideFooter {
  display: none;
}
</style>
